import React from "react";
import { Box } from "@mui/material";
import { dt } from "../../../shared/themes/redesignTokens";

interface ArchiveViewToggleProps {
  activeView: "active" | "archived";
  activeCount: number;
  archivedCount: number;
  onViewChange: (view: "active" | "archived") => void;
  activeLabel: string;
  archivedLabel: string;
}

const ArchiveViewToggle = ({
  activeView,
  activeCount,
  archivedCount,
  onViewChange,
  activeLabel,
  archivedLabel,
}: ArchiveViewToggleProps) => {
  const pillBase = {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: 500,
    fontFamily: dt.font,
    cursor: "pointer",
    transition: "all 0.2s ease",
    userSelect: "none" as const,
    whiteSpace: "nowrap" as const,
    lineHeight: "20px",
  };

  const countBadge = (count: number, isSelected: boolean, color: string) => (
    <Box
      component="span"
      sx={{
        fontSize: "11px",
        fontFamily: dt.fontMono,
        fontWeight: 700,
        backgroundColor: isSelected ? `${color}20` : "#F3F4F6",
        color: isSelected ? color : dt.textMuted,
        borderRadius: "10px",
        padding: "1px 7px",
        lineHeight: "16px",
        transition: "all 0.2s ease",
      }}
    >
      {count}
    </Box>
  );

  const archivedColor = "#6B7280";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "#F3F4F6",
        borderRadius: "22px",
        padding: "3px",
        gap: "2px",
      }}
    >
      {/* Active pill */}
      <Box
        onClick={() => onViewChange("active")}
        sx={{
          ...pillBase,
          backgroundColor: activeView === "active" ? "#FFFFFF" : "transparent",
          color: activeView === "active" ? dt.blue : dt.textSecondary,
          boxShadow: activeView === "active" ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
          "&:hover": {
            backgroundColor: activeView === "active" ? "#FFFFFF" : "#E5E7EB",
          },
        }}
      >
        {activeLabel}
        {countBadge(activeCount, activeView === "active", dt.blue)}
      </Box>

      {/* Archived pill */}
      <Box
        onClick={() => onViewChange("archived")}
        sx={{
          ...pillBase,
          backgroundColor: activeView === "archived" ? "#FFFFFF" : "transparent",
          color: activeView === "archived" ? archivedColor : dt.textSecondary,
          boxShadow: activeView === "archived" ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
          "&:hover": {
            backgroundColor: activeView === "archived" ? "#FFFFFF" : "#E5E7EB",
          },
        }}
      >
        {archivedLabel}
        {countBadge(archivedCount, activeView === "archived", archivedColor)}
      </Box>
    </Box>
  );
};

export default ArchiveViewToggle;
